
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexWezJNHxgLEwK1FEGj1KnlKO_huNX6Mdc1_45YyA5s03hQMeta } from "/home/ploi/nmodata.nl/front-end/pages/index.vue?macro=true";
import { default as index8r3pX_LILgd66XWFXscPiovGCuoq_45sR3_45IParbTzNwkMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/index.vue?macro=true";
import { default as loginFku8X3O7sN2el_LS7PSUC5BJHEruB6UE1PTBEXWy_45R0Meta } from "/home/ploi/nmodata.nl/front-end/pages/management/login.vue?macro=true";
import { default as _91tool_93M0uT8L50AyOsenpmza_45_JB1oH0aGb1V9gwGKax92vogMeta } from "/home/ploi/nmodata.nl/front-end/pages/[category]/[tool].vue?macro=true";
import { default as publicatie_45regelsUmMqrEznF4znWUMaVSoo9vyWY2aTDdzQCzdj4k5SH0cMeta } from "/home/ploi/nmodata.nl/front-end/pages/publicatie-regels.vue?macro=true";
import { default as activate9b4_45dDMjlGNX1jQMir9hHSVkrKcz9bl_4507WLR5ImOhEMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/activate.vue?macro=true";
import { default as indexqkKEYB7D5QAGCsLqHwgehcCnZVABiVr0kbnuNfp6FEAMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/users/[id]/index.vue?macro=true";
import { default as permissions0MuKdlfC_mTPij78cGC089hPa3xnF0rSYB_458I_45Ju8xsMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/users/[id]/permissions.vue?macro=true";
import { default as _91id_93YLzaOrsR98sZ6CdvipMo8cssRwBB7WT7iaYikRP6XKEMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/users/[id].vue?macro=true";
import { default as activate1lK3sABTSeIkoPlJ92u1noewh_2gCI3frT5PpQmpi1gMeta } from "/home/ploi/nmodata.nl/front-end/pages/subscription/activate.vue?macro=true";
import { default as overviewRpGd_Mhw9bn1dsDSvYecfDIaayB_45mucG1DBYGzydV8UMeta } from "/home/ploi/nmodata.nl/front-end/pages/subscription/overview.vue?macro=true";
import { default as indexRq57Bc3EwC2JCkFyDSgdsgK8bWfbU7Voh3_sgoooKHgMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/users/index.vue?macro=true";
import { default as index4nUrEC2AsyTN6AsGf0QMldTqCgJDFSRLFiPZs0SlN1kMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/edit/index.vue?macro=true";
import { default as mappingscG9J8lddQ7CqE6oz2GgoiKcI9FagP09l0jY1wFefh9oMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/edit/mappings.vue?macro=true";
import { default as edit9bZTYr1WQcMT2qwmQiX1fICmlpeF2J1Ln6OawyWaTVsMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/edit.vue?macro=true";
import { default as indexRz3ze2fvvd81BgJ1hsDdXiRViTNpa_45DHrMSTsbTLwbAMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/index.vue?macro=true";
import { default as _91id_933_wbJH3cFSZa_nGW9Q6a3Gs9wXMYu4_qSUcfaDNzBZAMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/subscriptions/[id].vue?macro=true";
import { default as index0OEzuOY17wBnm4_45wrH1RGQJSnTaGl0QRZqFaM0_455VyQMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/subscriptions/index.vue?macro=true";
import { default as created72IXygtelZvby1E4lZfJJBuusrj4Yey83kMW152tfocMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/subscriptions/created.vue?macro=true";
import { default as confirm_45password_45reset2n_45r8TmBtdqBC5Y7_7Kmql94S1xRyGDFzUg46a5rtTwMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/confirm-password-reset.vue?macro=true";
import { default as request_45password_45resetGe9shWLwTRtjNWSgJbQZDF_O0d5pjq2lttMXb9Kq4SYMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/request-password-reset.vue?macro=true";
import { default as indexF4_JhVXkkpPPuv7Tsck1iGwmZvUlb9PbohRw0uoZ_C8Meta } from "/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/failed-publications/index.vue?macro=true";
import { default as _91publicationId_93_45_VaaDufkmR6WkrL08a5sjLsofaXSK_ct_Pi5vIjRJMMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/publications/[publicationId].vue?macro=true";
import { default as _91failedPublicationId_93MzSMApZ2K8q4MxC_45f5o3NlLyshS1TYnVTG_45H4PicmRsMeta } from "/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/failed-publications/[failedPublicationId].vue?macro=true";
import { default as component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0Meta } from "/home/ploi/nmodata.nl/front-end/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0 } from "/home/ploi/nmodata.nl/front-end/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    meta: indexWezJNHxgLEwK1FEGj1KnlKO_huNX6Mdc1_45YyA5s03hQMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/index.vue")
  },
  {
    name: "management",
    path: "/management",
    meta: index8r3pX_LILgd66XWFXscPiovGCuoq_45sR3_45IParbTzNwkMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/index.vue")
  },
  {
    name: "management-login",
    path: "/management/login",
    meta: loginFku8X3O7sN2el_LS7PSUC5BJHEruB6UE1PTBEXWy_45R0Meta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/login.vue")
  },
  {
    name: "category-tool",
    path: "/:category()/:tool()",
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/[category]/[tool].vue")
  },
  {
    name: "publicatie-regels",
    path: "/publicatie-regels",
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/publicatie-regels.vue")
  },
  {
    name: "management-activate",
    path: "/management/activate",
    meta: activate9b4_45dDMjlGNX1jQMir9hHSVkrKcz9bl_4507WLR5ImOhEMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/activate.vue")
  },
  {
    name: _91id_93YLzaOrsR98sZ6CdvipMo8cssRwBB7WT7iaYikRP6XKEMeta?.name,
    path: "/management/users/:id()",
    meta: _91id_93YLzaOrsR98sZ6CdvipMo8cssRwBB7WT7iaYikRP6XKEMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/users/[id].vue"),
    children: [
  {
    name: "management-users-id",
    path: "",
    meta: indexqkKEYB7D5QAGCsLqHwgehcCnZVABiVr0kbnuNfp6FEAMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/users/[id]/index.vue")
  },
  {
    name: "management-users-id-permissions",
    path: "permissions",
    meta: permissions0MuKdlfC_mTPij78cGC089hPa3xnF0rSYB_458I_45Ju8xsMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/users/[id]/permissions.vue")
  }
]
  },
  {
    name: "subscription-activate",
    path: "/subscription/activate",
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/subscription/activate.vue")
  },
  {
    name: "subscription-overview",
    path: "/subscription/overview",
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/subscription/overview.vue")
  },
  {
    name: "management-users",
    path: "/management/users",
    meta: indexRq57Bc3EwC2JCkFyDSgdsgK8bWfbU7Voh3_sgoooKHgMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/users/index.vue")
  },
  {
    name: edit9bZTYr1WQcMT2qwmQiX1fICmlpeF2J1Ln6OawyWaTVsMeta?.name,
    path: "/management/tools/:id()/edit",
    meta: edit9bZTYr1WQcMT2qwmQiX1fICmlpeF2J1Ln6OawyWaTVsMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/edit.vue"),
    children: [
  {
    name: "management-tools-id-edit",
    path: "",
    meta: index4nUrEC2AsyTN6AsGf0QMldTqCgJDFSRLFiPZs0SlN1kMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/edit/index.vue")
  },
  {
    name: "management-tools-id-edit-mappings",
    path: "mappings",
    meta: mappingscG9J8lddQ7CqE6oz2GgoiKcI9FagP09l0jY1wFefh9oMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/edit/mappings.vue")
  }
]
  },
  {
    name: "management-tools-id",
    path: "/management/tools/:id()",
    meta: indexRz3ze2fvvd81BgJ1hsDdXiRViTNpa_45DHrMSTsbTLwbAMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/index.vue")
  },
  {
    name: "management-subscriptions-id",
    path: "/management/subscriptions/:id()",
    meta: _91id_933_wbJH3cFSZa_nGW9Q6a3Gs9wXMYu4_qSUcfaDNzBZAMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/subscriptions/[id].vue")
  },
  {
    name: "management-subscriptions",
    path: "/management/subscriptions",
    meta: index0OEzuOY17wBnm4_45wrH1RGQJSnTaGl0QRZqFaM0_455VyQMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/subscriptions/index.vue")
  },
  {
    name: "management-subscriptions-created",
    path: "/management/subscriptions/created",
    meta: created72IXygtelZvby1E4lZfJJBuusrj4Yey83kMW152tfocMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/subscriptions/created.vue")
  },
  {
    name: "management-confirm-password-reset",
    path: "/management/confirm-password-reset",
    meta: confirm_45password_45reset2n_45r8TmBtdqBC5Y7_7Kmql94S1xRyGDFzUg46a5rtTwMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/confirm-password-reset.vue")
  },
  {
    name: "management-request-password-reset",
    path: "/management/request-password-reset",
    meta: request_45password_45resetGe9shWLwTRtjNWSgJbQZDF_O0d5pjq2lttMXb9Kq4SYMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/request-password-reset.vue")
  },
  {
    name: "management-tools-id-failed-publications",
    path: "/management/tools/:id()/failed-publications",
    meta: indexF4_JhVXkkpPPuv7Tsck1iGwmZvUlb9PbohRw0uoZ_C8Meta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/failed-publications/index.vue")
  },
  {
    name: "management-tools-id-publications-publicationId",
    path: "/management/tools/:id()/publications/:publicationId()",
    meta: _91publicationId_93_45_VaaDufkmR6WkrL08a5sjLsofaXSK_ct_Pi5vIjRJMMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/publications/[publicationId].vue")
  },
  {
    name: "management-tools-id-failed-publications-failedPublicationId",
    path: "/management/tools/:id()/failed-publications/:failedPublicationId()",
    meta: _91failedPublicationId_93MzSMApZ2K8q4MxC_45f5o3NlLyshS1TYnVTG_45H4PicmRsMeta || {},
    component: () => import("/home/ploi/nmodata.nl/front-end/pages/management/tools/[id]/failed-publications/[failedPublicationId].vue")
  },
  {
    name: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0Meta?.name,
    path: "/luistercijfers-weekdata",
    component: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0
  },
  {
    name: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0Meta?.name,
    path: "/nmo-streaming-audio-standaard",
    component: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0
  },
  {
    name: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0Meta?.name,
    path: "/nmo-streaming-audio-standaard-weekdata",
    component: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0
  },
  {
    name: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0Meta?.name,
    path: "/nmo-podcast-en-audio-on-demand-standaard",
    component: component_45stubebQZzcI6wPNV35vMM77QmwrcUaiU9V01QBpSOub2_45g0
  }
]